import { ExternalBalance, Project } from 'static/classes/Accounting';
import { CSVPrinter } from 'static/classes/CSVPrinter';
import { COST_CENTER } from 'static/common/constants';
import { Modal } from 'bootstrap';

export function ExternalBalanceViewModel(data) {

	var self = this;
	self.type = "ExternalBalanceViewModel";

	data.rootvm = data.rootvm;
	self.web_host = data.rootvm.web_host;

	self.COST_CENTER = COST_CENTER

	// TOOD: check if needed
	self.csvprint = new CSVPrinter(data);

	self.is_busy = ko.observable(false);

	// TODO: check if can be removed
	self.show_aufwand = ko.observable(false);

	self.initialize = function () {
		self.is_busy(true);
		self.lookup_projects().then((projects) => {
			self.projects(projects.map(project => new Project(project)));
			self.is_busy(false);
		}).catch((error) => {
			notyf.error(error);
			console.error(error);
		}).finally(() => {
			self.is_busy(false);
		});
		self.lookup_external_balances().then(
			self.is_busy(false)
		)
	}

	self.lookup_projects = async () => {
		const response = await fetch(self.web_host + '/api/admin/projects', { headers: { 'Accept': 'application/json' }});
		const data = await response.json();
		if (data.success) {
			return data.projects
		} else {
			throw new Error(data.message)
		}
	};
	self.lookup_external_balances = function () {
		return $.ajax({
			url: self.web_host + '/api/admin/external-balances',
			type: 'GET',
			data: {
			},
			contentType: "application/json; charset=utf-8",
			success: function (data) {
				if (data.success) {
					self.external_balances(ko.utils.arrayMap(
						data.external_balances || [], function (item) {
							return new ExternalBalance(item)
						}));
				}
			},
			error: function (data) {
				console.log(data.statusText);
			}
		});
	};

	self.projects = ko.observableArray([]);

	self.external_balances = ko.observableArray([]);
	// filter
	self.filter_invoice_no = ko.observable('');
	self.filter_receiver_name = ko.observable('');
	self.filter_project_title = ko.observable('');
	self.filtered_external_balances = ko.pureComputed(() =>
		self.external_balances().filter((item) => {
			// invoice_number + is not fee
			let result_filter_invoice_no = true;
			if(self.filter_invoice_no()) {
				result_filter_invoice_no = item.external_balance_invoice_number().toString().includes(self.filter_invoice_no().toLowerCase())
			}
			// receiver_name
			let result_filter_receiver_name = true;
			if(self.filter_receiver_name()) {
				result_filter_receiver_name = item.receiver_name().toLowerCase().includes(self.filter_receiver_name().toLowerCase())
			}
			// project_title
			let result_filter_project_title = true;
			if(self.filter_project_title()) {
				result_filter_project_title = item.project_title().toLowerCase().includes(self.filter_project_title().toLowerCase())
			}
			return result_filter_invoice_no && result_filter_receiver_name && result_filter_project_title
		})
	);

	// sorting
	self.sort_asc = ko.observable(false);
	self.sort_desc = ko.pureComputed(() => !self.sort_asc());
	self.sort_by_invoice_number = ko.observable(false);
	self.sorted_filtered_external_balances = ko.pureComputed(() => {
		if (self.sort_by_invoice_number()) {
			return self.filtered_external_balances().sort((a,b) =>
				a.external_balance_invoice_number() < b.external_balance_invoice_number() ? 1 : -1
			)
		} else {
			return self.filtered_external_balances().sort((a,b) =>
				a.external_balance_date() <= b.external_balance_date() ? 1 : -1
	 		)
		}
	});

	// TODO: check if still needed
	self.is_expense = ko.observable(false);

	self.external_balance_date = ko.observable();
	self.external_balance_amount = ko.observable();
	self.external_balance_netto = ko.observable();
	self.external_extra_notes = ko.observable();
	self.external_project_uuid = ko.observable();
	self.external_cloud_link = ko.observable();
	self.related_fee = ko.observable();
	self.related_external = ko.observable();
	self.due_date = ko.observable();
	self.cost_center = ko.observable();

	self.external_receiver_name = ko.observable();
	self.external_balance_invoice_number = ko.observable();

	self.disable_add_amount = ko.computed(function () {
		if (self.is_expense()) {
			return !(self.external_balance_date() && self.external_balance_amount() &&
				self.external_balance_netto() && self.related_fee() &&
				self.related_external() && self.cost_center());
		}
		else {
			return !(self.external_balance_date() && self.external_balance_amount() && self.external_balance_netto() &&
				self.external_receiver_name() && self.external_balance_invoice_number() &&
				self.cost_center());

		}
	});


	self.new_eb_amount = ko.observable();
	self.new_eb_netto = ko.observable();
	self.new_eb_date = ko.observable();
	self.new_eb_notes = ko.observable();
	self.new_eb_cloud_link = ko.observable();
	self.new_eb_cost_center = ko.observable();
	self.new_eb_due_date = ko.observable();
	self.new_eb_receiver_name = ko.observable();
	self.new_eb_invoice_number = ko.observable();
	self.new_eb_project_uuid = ko.observable();

	self.selected_eb = ko.observable();
	self.show_edit_external_amount = function (external_balance) {
		self.new_eb_amount(external_balance.external_balance_amount());
		self.new_eb_netto(external_balance.external_balance_netto());
		self.new_eb_notes(external_balance.extra_notes());
		self.new_eb_date(external_balance.external_balance_date());
		self.new_eb_cloud_link(external_balance.external_cloud_link());
		self.new_eb_due_date(external_balance.due_date());
		self.new_eb_cost_center(external_balance.cost_center());
		self.new_eb_receiver_name(external_balance.receiver_name());
		self.new_eb_invoice_number(external_balance.external_balance_invoice_number());
		self.new_eb_project_uuid(external_balance.project_uuid());

		self.selected_eb(external_balance);
		const changeExternalBalanceModal = document.getElementById('changeExternalBalanceModal');
		Modal.getOrCreateInstance(changeExternalBalanceModal).show();
	};

	self.edit_external_amount = function (external_balance) {

		let due_date = null;
		if (self.new_eb_due_date()) {
			due_date = self.new_eb_due_date();
		}
		return $.ajax({

			url: self.web_host + '/api/admin/edit-external-balance',
			type: 'POST',
			data: ko.toJSON({
				external_balance_uuid: self.selected_eb().external_balance_uuid(),
				amount: self.new_eb_amount(),
				netto: self.new_eb_netto(),
				date: self.new_eb_date(),
				due_date: due_date,
				extra_notes: self.new_eb_notes(),
				cloud_link: self.new_eb_cloud_link(),
				cost_center: self.new_eb_cost_center(),
				receiver_name: self.new_eb_receiver_name(),
				invoice_number: self.new_eb_invoice_number(),
				project_uuid: self.new_eb_project_uuid()
			}),
			processData: false,

			contentType: "application/json; charset=utf-8",

			success: function (data) {

				if (data.success) {
					self.selected_eb().external_balance_amount(self.new_eb_amount());
					self.selected_eb().external_balance_netto(self.new_eb_netto());
					self.selected_eb().extra_notes(self.new_eb_notes());
					self.selected_eb().external_balance_date(self.new_eb_date());

					if (self.new_eb_due_date()) {
						self.selected_eb().due_date(self.new_eb_due_date());
					}

					self.selected_eb().external_cloud_link(self.new_eb_cloud_link());
					self.selected_eb().cost_center(self.new_eb_cost_center());
					self.selected_eb().receiver_name(self.new_eb_receiver_name());
					self.selected_eb().project_uuid(self.new_eb_project_uuid());
					self.selected_eb().project_title(self.projects().find((item) => item.project_uuid() === self.new_eb_project_uuid())?.title());
					self.selected_eb().external_balance_invoice_number(self.new_eb_invoice_number());

					notyf.success(data.message);
				}
				else {
					notyf.error(data.message);
				}

			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				notyf.error(response.message);
			},
			complete: function () {
			}
		});
	};



	self.delete_external_amount = function (external_balance) {
		if (confirm('are you sure you want to delete? ')) {
			return $.ajax({

				url: self.web_host + '/api/admin/delete-external-balance',
				type: 'POST',
				data: ko.toJSON({
					external_balance_uuid: external_balance.external_balance_uuid(),
				}),
				processData: false,

				contentType: "application/json; charset=utf-8",

				success: function (data) {

					if (data.success) {
						self.external_balances.remove(external_balance)
						//self.lookup_balance_kpi_data();
						notyf.success("Removed!");
					}
					else {
						notyf.error(data.message);
					}

				},
				error: function (jqXHR, errorStatus, thrownError) {
					var response = jQuery.parseJSON(jqXHR.responseText);
					notyf.error(response.message);
				},
				complete: function () {
				}
			});
		}
	};


	self.save_external_amount = function () {

		return $.ajax({

			url: self.web_host + '/api/admin/add-external-balance',
			type: 'POST',
			data: ko.toJSON({
				date: self.external_balance_date(),
				amount: self.external_balance_amount(),
				netto: self.external_balance_netto(),
				extra_notes: self.external_extra_notes(),
				project_uuid: self.external_project_uuid(),
				due_date: self.due_date(),
				is_expense: self.is_expense(),
				related_fee: self.related_fee(),
				related_external_number: self.related_external(),
				receiver_name: self.external_receiver_name(),
				external_balance_invoice_number: self.external_balance_invoice_number(),
				cost_center: self.cost_center(),
				external_cloud_link: self.external_cloud_link()
			}),
			processData: false,

			contentType: "application/json; charset=utf-8",

			success: function (data) {

				if (data.success) {
					//self.lookup_balance_kpi_data();
					data.external_balance.project_title = self.projects().find((item) => item.project_uuid() === self.external_project_uuid())?.title();
					self.external_balances.unshift(new ExternalBalance(data.external_balance))
					self.external_extra_notes(undefined);
					self.external_balance_amount(undefined);
					self.external_balance_netto(undefined);
					self.due_date(undefined);
					notyf.success("Added!");
				}
				else {
					notyf.error(data.message);
				}

			},
			error: function (jqXHR, errorStatus, thrownError) {
				var response = jQuery.parseJSON(jqXHR.responseText);
				notyf.error(response.message);
			},
			complete: function () {
			}
		});
	};
};
